import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { noop } from 'lodash';
import { useRef, useState } from 'react';
import { Body } from '../../../components/internal/FlyOut/components/Body.js';
import { Container } from '../../../components/internal/FlyOut/components/Container.js';
import { SlideUpIn } from '../../../primitives/Transition/index.js';
const FlyOutComponent = ({
  visible,
  overlapping,
  onEntered = noop,
  children,
  ...restProps
}) => {
  const [entered, setEntered] = useState(false);
  const nodeRef = useRef(null);
  return _jsx(Container, {
    ...restProps,
    clickable: visible,
    overlapping: overlapping,
    overflowable: entered,
    children: _jsx(SlideUpIn, {
      nodeRef: nodeRef,
      classNames: "slideUpIn",
      timeout: 300,
      appear: true,
      in: visible,
      onEntered: () => {
        setEntered(true);
        onEntered();
      },
      onExit: () => {
        setEntered(false);
      },
      children: _jsx(Body, {
        ref: nodeRef,
        children: children
      })
    })
  });
};
export const FlyOut = /*#__PURE__*/_styled(FlyOutComponent, process.env.NODE_ENV === "production" ? {
  target: "e43nv1j0"
} : {
  target: "e43nv1j0",
  label: "FlyOut"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZseU91dC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQjhDIiwiZmlsZSI6IkZseU91dC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBub29wIH0gZnJvbSAnbG9kYXNoJztcbmltcG9ydCB7IHVzZVJlZiwgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBCb2R5IH0gZnJvbSAnLi4vLi4vLi4vY29tcG9uZW50cy9pbnRlcm5hbC9GbHlPdXQvY29tcG9uZW50cy9Cb2R5LmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uL2NvbXBvbmVudHMvaW50ZXJuYWwvRmx5T3V0L2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IFNsaWRlVXBJbiB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvVHJhbnNpdGlvbi9pbmRleC5qcyc7XG5jb25zdCBGbHlPdXRDb21wb25lbnQgPSAoeyB2aXNpYmxlLCBvdmVybGFwcGluZywgb25FbnRlcmVkID0gbm9vcCwgY2hpbGRyZW4sIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgY29uc3QgW2VudGVyZWQsIHNldEVudGVyZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuICAgIGNvbnN0IG5vZGVSZWYgPSB1c2VSZWYobnVsbCk7XG4gICAgcmV0dXJuIChfanN4KENvbnRhaW5lciwgeyAuLi5yZXN0UHJvcHMsIGNsaWNrYWJsZTogdmlzaWJsZSwgb3ZlcmxhcHBpbmc6IG92ZXJsYXBwaW5nLCBvdmVyZmxvd2FibGU6IGVudGVyZWQsIGNoaWxkcmVuOiBfanN4KFNsaWRlVXBJbiwgeyBub2RlUmVmOiBub2RlUmVmLCBjbGFzc05hbWVzOiBcInNsaWRlVXBJblwiLCB0aW1lb3V0OiAzMDAsIGFwcGVhcjogdHJ1ZSwgaW46IHZpc2libGUsIG9uRW50ZXJlZDogKCkgPT4ge1xuICAgICAgICAgICAgICAgIHNldEVudGVyZWQodHJ1ZSk7XG4gICAgICAgICAgICAgICAgb25FbnRlcmVkKCk7XG4gICAgICAgICAgICB9LCBvbkV4aXQ6ICgpID0+IHtcbiAgICAgICAgICAgICAgICBzZXRFbnRlcmVkKGZhbHNlKTtcbiAgICAgICAgICAgIH0sIGNoaWxkcmVuOiBfanN4KEJvZHksIHsgcmVmOiBub2RlUmVmLCBjaGlsZHJlbjogY2hpbGRyZW4gfSkgfSkgfSkpO1xufTtcbmV4cG9ydCBjb25zdCBGbHlPdXQgPSBzdHlsZWQoRmx5T3V0Q29tcG9uZW50KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUZseU91dC5qcy5tYXAiXX0= */");